import { useCloseDialog } from "hooks/useCloseDialog";
import { ModalAdapterProps } from "constants/navigation";

// Named type alias for the tuple:
export type ModalAdapterReturn<TParams = unknown> = [
  params: TParams,
  returnTo: string,
  closeDialog: ReturnType<typeof useCloseDialog>,
];

/**
 * Provides utility functions for managing hash modals.
 */
export const useModalAdapter = <TParams = unknown>(
  modalType: string,
  modalProps: ModalAdapterProps,
): ModalAdapterReturn<TParams> => {
  const { hash } = modalProps;
  const params = JSON.parse(hash[modalType] || null);

  const { returnTo } = hash;
  const decodedReturnTo = returnTo ? atob(returnTo) : "";

  const closeDialog = useCloseDialog(decodedReturnTo);

  return [params, decodedReturnTo, closeDialog];
};
